module.exports = __webpack_public_path__ + "img/pmonth1.4b195af0.png";